import type { UnitFoldSource } from './schemaForm.types';

/** No unit folds: the default when the host remembers nothing. */
export const NO_UNIT_FOLD: UnitFoldSource = { useFold: () => null };
